/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dropdown, Image, TableColumnsType, Tag } from "antd";
import TableUi from "../../../../../../atoms/Table";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CrossIcon, DeleteIcon } from "../../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../../atoms/ConfirmDelete";
import { SubServiceType } from "../../../ducks/types";
import { deleteService, updateServiceStatus } from "../../../ducks/services";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { getServiceListing } from "../../../ducks/actions";
import { useAppDispatch } from "../../../../../../config/hooks";
import { MoreOutlined } from "@ant-design/icons";
import EmptyCard from "../../../../../../atoms/EmptyCard";

interface PropsType {
  data: any[];
  serviceLineId: string;
  companyId: string;
  parentId: string;
  subArchived?: boolean;
  setActiveRecord?: React.Dispatch<React.SetStateAction<SubServiceType | null>>;
  setActiveType?: React.Dispatch<React.SetStateAction<string | null>>;
}

export default function SubServiceTable(props: PropsType) {
  const {
    data,
    serviceLineId,
    companyId,
    parentId,
    setActiveRecord,
    setActiveType,
    subArchived,
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableRecord, setTableRecord] = useState<SubServiceType | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isAllDeleteModalOpen, setIsAllDeleteModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [archivePopUp, setArchivePopUp] = useState(false);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/company-settings/${parentId}/${tableRecord?.id}/${serviceLineId}/${companyId}`
            );
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status === "active"
              ? setArchivePopUp(true)
              : archiveFunction();

            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<SubServiceType> = [
    {
      title: "Subservice name",
      dataIndex: "name",
      width: 216,
      fixed: "left",
      sorter: (a, b) =>
        (a?.name ?? "").toString().localeCompare((b?.name ?? "").toString()),
      render: (text) =>
        text ? (
          <>
            {text}{" "}
            {subArchived && (
              <span style={{ color: "#98A3A9" }}>(archived)</span>
            )}
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "Category",
      dataIndex: "city",
      width: 147,
      render: (text) => text || "-",
    },
    {
      title: "Takeoff measurement",
      dataIndex: "takeoff",
      width: 250,
      render: (text) => (text?.name ? text?.name : "-"),
    },
    {
      title: "Qty unit",
      dataIndex: "takeoff",
      width: 250,
      render: (text) =>
        text?.unit?.name
          ? `${text?.unit?.singular_name} (${text?.unit?.name})`
          : "-",
    },
    {
      title: "Production rate",
      dataIndex: "production_rate",
      width: 250,
      render: (value) => {
        if (!value && value !== 0) return "-";

        return new Intl.NumberFormat("en-US").format(value);
      },
    },
    {
      title: "Materials",
      dataIndex: "serviceMaterials",
      width: 173,
      render: (text) =>
        text?.length > 0
          ? text?.map(
              (
                e: {
                  material_category: { name: string; color: string };
                  material: { name: string };
                },
                i: number
              ) => (
                <Tag
                  className={e?.material_category?.color}
                  key={i}
                  style={{ marginRight: 4 }}
                >
                  {e?.material_category?.name || e?.material?.name}
                </Tag>
              )
            )
          : "-",
    },
    {
      title: "Equipment",
      dataIndex: "serviceEquipments",
      width: 250,
      render: (text) =>
        text?.length > 0
          ? text?.map(
              (
                e: {
                  equipment: { name: string };
                },
                i: number
              ) => (
                <Tag key={i} style={{ marginRight: 4 }}>
                  {e?.equipment?.name}
                </Tag>
              )
            )
          : "-",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      width: 250,
      render: (text) => text?.replace(/_/g, "-") ?? "-",
    },
    {
      title: "Who performs",
      dataIndex: "cont_person_email",
      width: 250,
      render: (text) => text ?? "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const archiveFunction = () => {
    setLoading(true);
    const payload = {
      status: tableRecord?.status === "active" ? "archived" : "active",
    };
    updateServiceStatus(tableRecord?.id as string, payload)
      .then(() => {
        setLoading(false);
        setArchivePopUp(false);

        const payload = {
          status: "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        SuccessMessage(
          `Subservice ${
            tableRecord?.status === "active" ? "archived" : "activated"
          }`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteFunction = () => {
    setLoading(true);
    const tableId =
      selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id || ""];
    deleteService(tableId)
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setIsAllDeleteModalOpen(false);

        const payload = {
          status: "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        SuccessMessage("Subservice deleted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmArchive = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        paragraph={
          <>
            Are you sure you want to archive <b>{tableRecord?.name}</b>?<br />
            <br />
            This {tableRecord?.type === "simple"
              ? "service"
              : "subservice"}{" "}
            won’t be available for use.
          </>
        }
        btnText={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete <b>{tableRecord?.name}</b>?<br />{" "}
            <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete subservice"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const deleteAllUsersPopUp = {
    visibility: isAllDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsAllDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete the selected services? <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete services"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsAllDeleteModalOpen(false),
  };

  const onClickRow = (record: SubServiceType) => {
    return {
      onClick: () => {
        setActiveType && setActiveType("simpleSubService");
        setActiveRecord && setActiveRecord(record);
      },
    };
  };

  console.log("data", data);

  return (
    <>
      <TableUi<SubServiceType>
        columns={columns}
        data={{
          count: data?.length,
          data: data || [],
        }}
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        onClickRow={setActiveRecord ? onClickRow : undefined}
      />

      {data?.length === 0 && (
        <div className="empty_wrap subservice_empty">
          <EmptyCard
            imageHeight={70}
            title={
              subArchived
                ? "There are no archived subservices"
                : "There are no active subservices"
            }
            description=""
            image={
              subArchived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar" style={{ minWidth: "235px" }}>
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "service " : "services "}`}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsAllDeleteModalOpen(true);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...confirmArchive} />
      <PopUp {...confirmDeletePopUp} />
      <PopUp {...deleteAllUsersPopUp} />
    </>
  );
}
